import { LocalStorageKeys } from './localStorage'

export const getGraphQlEndpoint = () => {
    if (process.env.NEXT_PUBLIC_ENVIRONMENT_NAME === 'development') {
        return typeof window !== 'undefined'
            ? window.localStorage.getItem(LocalStorageKeys.GRAPHQL_ENDPOINT)
            : process.env.NEXT_PUBLIC_GRAPHQL_ENDPOINT
    }

    return process.env.NEXT_PUBLIC_GRAPHQL_ENDPOINT
}
